import React from 'react';
import PropTypes from 'prop-types';
import {Table} from '@devexpress/dx-react-grid-material-ui';

export const ColumnDefinedCell = (props) => {
  const {
    column: {cellClassName},
  } = props;

  return <Table.Cell className={cellClassName} {...props} />;
};

ColumnDefinedCell.propTypes = {
  column: PropTypes.shape({
    cellClassName: PropTypes.string,
  }).isRequired,
};
